"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export default function PortalBrowserBranding({ browserBranding }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!browserBranding?.title) return;
    document.title = browserBranding.title;
  }, [browserBranding?.title, pathname, searchParams]);

  return null;
}
